<template>
  <div>

    <div class="mobile_navigation" :class="{ show : showMobileNavi }">

      <div class="row column small-20 small-offset-2">
        <mq-navigation :navItems="navItems" :login="login" @close-nav="toggleMobileNavi"></mq-navigation>
      </div>

      <div class="row column contact">
        <p>{{ contact.hint }}</p>
        <mq-link class="contact-link" :destination="contact.url" size="small" :color="buttonColor" type="button" @click.native="toggleMobileNavi">{{ contact.text }}</mq-link>
      </div>

    </div>

    <div class="row collapse hide-for-mediumlarge">
      <div class="column small-20 small-offset-1">
        <div class="logo-wrapper">
          <router-link :to="rootPath">
            <img class="page-logo" :src="logoUrl"/>
          </router-link>
        </div>
      </div>
    </div>

    <mq-hamburger @click.native="toggleMobileNavi" :closeActive="showMobileNavi" :extraClasses="['hide-for-mediumlarge']"></mq-hamburger>

  </div>
</template>

<script>
  export default {
    name: 'MobileNavigation',

    props: {
      header: {
        required: true,
        type: Object
      }
    },

    data () {
      return {
        showMobileNavi: false,
      }
    },

    mounted() {
      this.addTrackingDataToRegisterButton({
        element: this.$el.querySelector('a.moqo_link.contact-link'),
        section: 'navigation-mobile'
      })
    },

    methods: {
      toggleMobileNavi (force = '') {
        if (force === 'force_off') {
          this.showMobileNavi = false
          document.body.classList.remove('mobile-navi-active')
          return true
        }

        this.showMobileNavi = !this.showMobileNavi
        document.body.classList.toggle('mobile-navi-active')
      },
      freezeVp (e) {
        if (this.showMobileNavi) {
          e.preventDefault();
        }
      },
      controlBodyScrolling() {
        document.body.addEventListener("touchmove", this.freezeVp, false)
        window.addEventListener("orientationchange", () => {
          if (window.orientation === 90 || window.orientation === 180) this.toggleMobileNavi('force_off')
        });
      }
    },

    computed: {
      contact     () { return this.header.contact },
      login       () { return this.header.login },
      navItems    () { return this.header.navItems },
      rootPath    () { return this.header.rootPath },
      buttonColor () { return this.header.buttonColor },

      logoUrl () {
        let logo = this.teamsiteConfig.navigation_logo || this.teamsiteConfig.logo
        if (logo) {
          return logo.thumb_url || logo.medium_url || logo.url
        }
      }
    }
  }
</script>

<style lang="scss">
// mobile navigation scrolling fix
body.mobile-navi-active{
  overflow: hidden;
}

.mobile-nav-btn {
  top: rem-calc(30);
  right: xy-cell-size(1/24);
  transition: top 50ms;

  .header--with-bg & {
    top: rem-calc(22);
  }
}

.mobile_navigation {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  min-height: 100vh;
  overflow-y: auto;
  max-height: 100%;
  background-color: $color-light-grey;

  &.show {
    @include breakpoint(medium down) {
      display: block;
    }
  }

  ul.navigation {
    margin: rem-calc(112) 0 rem-calc(48);
    float: none;
    width: 100%;
    text-align: center;

    li {
      float: none;
      width: 100%;
      margin: 0;
      padding: 0.75rem 0;
    }

    a, router-link {
      font-size: rem-calc(20);
      font-weight: $font-weight-regular;
    }
  }

  .contact {
    text-align: center;

    .moqo_link {
      display: inline-block;
      color: $color-white;
    }
  }
}

.page-logo {
  height: 100%;
  width: auto;
  float: left;
}
.logo-wrapper {
  // required to show the logo in front of mobile nav
  position: relative;
  display: inline-block;
  height: 60px;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/MobileNavigation.vue